import { Outlet } from "react-router-dom";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { BookA, ChartBarStacked, Scroll, Tag } from "lucide-react";
import OverViewIcon from "../Icons/OverViewIcon";
import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../Icons/WelcomeIcon";
export const shouldShowWelcome = getKey("shouldShowWelcome");
export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      ...(shouldShowWelcome === "true" || shouldShowWelcome === null
        ? [
            {
              name: "Welcome",
              href: "/blog",
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: "Overview",
              href: "/blog/overview",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: "Overview",
              href: "/blog",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: "Blog",
    href: "",
    icon: "",
    children: [
      {
        name: "Posts",
        href: "/blog/post",
        icon: Scroll,
        activeIcon: Scroll,
      },
      {
        name: "Author",
        href: "/blog/author",
        icon: BookA,
        activeIcon: BookA,
      },
      {
        name: "Category",
        href: "/blog/category",
        icon: ChartBarStacked,
        activeIcon: ChartBarStacked,
      },
      {
        name: "Tags",
        href: "/blog/tag",
        icon: Tag,
        activeIcon: Tag,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 h-full overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
